var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-upsell" }, [
    _c(
      "svg",
      {
        attrs: {
          width: "14",
          height: "14",
          viewBox: "0 0 14 14",
          fill: "none",
        },
      },
      [
        _c("rect", {
          attrs: {
            x: "3",
            y: "6",
            width: "8",
            height: "7",
            rx: "1",
            stroke: "currentColor",
            "stroke-width": "1.2",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M5 6V4a2 2 0 014 0v2",
            stroke: "currentColor",
            "stroke-width": "1.2",
            "stroke-linecap": "round",
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c("span", [_vm._v("Premium content - Upgrade to access expert analysis")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }